module.exports = __webpack_public_path__ + "static/IMG_5704-01c2eafa0b58726b69652182f40982f5.jpg";